var map = {
	"./discount_10.png": "2gWc",
	"./discount_100.png": "Wbkt",
	"./discount_15.png": "supt",
	"./discount_20.png": "YPi8",
	"./discount_25.png": "OEgv",
	"./discount_30.png": "XT2S",
	"./discount_35.png": "OmtT",
	"./discount_40.png": "7C2O",
	"./discount_45.png": "24Qa",
	"./discount_5.png": "DSVE",
	"./discount_50.png": "VNWX",
	"./discount_55.png": "9GLZ",
	"./discount_60.png": "j804",
	"./discount_65.png": "OO0c",
	"./discount_70.png": "V0dA",
	"./discount_75.png": "Vyb6",
	"./discount_80.png": "76Np",
	"./discount_85.png": "KLA/",
	"./discount_90.png": "ubw1",
	"./discount_95.png": "JC0t"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8aJt";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/product-icon ^\.\/discount_.*\.png$
// module id = 8aJt
// module chunks = 71